import { render, staticRenderFns } from "./cardInternationalDetail.vue?vue&type=template&id=2f244589&scoped=true"
import script from "./cardInternationalDetail.vue?vue&type=script&lang=js"
export * from "./cardInternationalDetail.vue?vue&type=script&lang=js"
import style0 from "./cardInternationalDetail.vue?vue&type=style&index=0&id=2f244589&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f244589",
  null
  
)

export default component.exports